import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store';

interface ProductMeta {
  id: number;
  title: string;
  image_url: string;
}

const initialState: ProductMeta[] = [];

const productMetaSlice = createSlice({
  name: 'productMeta',
  initialState,
  reducers: {
    addProductMeta: (state, action: PayloadAction<ProductMeta>) => {
      state.push(action.payload);
    },
    removeProductMeta: (state, action: PayloadAction<number>) => {
      state.splice(action.payload, 1);
    },
  },
});

export const productMetaState = (state: RootState) => state.productMeta;

export const { addProductMeta, removeProductMeta } = productMetaSlice.actions;

export default productMetaSlice.reducer;
